var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03819 0.625854C8.87715 0.631353 8.72209 0.688208 8.59567 0.78811L1.43966 6.42579C0.531419 7.14156 0 8.23531 0 9.39165V19.0031C0 19.6897 0.572166 20.2619 1.25872 20.2619H6.29359C6.98014 20.2619 7.55231 19.6897 7.55231 19.0031V13.9683C7.55231 13.8197 7.6555 13.7165 7.80405 13.7165H10.3215C10.47 13.7165 10.5732 13.8197 10.5732 13.9683V19.0031C10.5732 19.6897 11.1454 20.2619 11.8319 20.2619H16.8668C17.5534 20.2619 18.1255 19.6897 18.1255 19.0031V9.39165C18.1255 8.23531 17.5941 7.14156 16.6859 6.42579L9.52987 0.78811C9.39021 0.677784 9.21608 0.62032 9.03819 0.625854ZM9.06277 2.34282L15.7517 7.61272C16.2975 8.04289 16.6151 8.69716 16.6151 9.39165V18.7514H12.0837V13.9683C12.0837 13.0041 11.2856 12.2061 10.3215 12.2061H7.80405C6.8399 12.2061 6.04185 13.0041 6.04185 13.9683V18.7514H1.51046V9.39165C1.51046 8.69716 1.82803 8.04289 2.37386 7.61272L9.06277 2.34282Z",
    fill: "#041967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePrimary);
export default __webpack_public_path__ + "static/media/home_primary.134d87325b32d72d1638b81f6dd16671.svg";
export { ForwardRef as ReactComponent };